import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  InsertDocumentAssessmentResultMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDocumentAssessmentResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertDocumentAssessmentResultInput {
  Rating: number;
  DocumentIds: string[];
  AssessmentId?: InputMaybe<string>;
  TestDate?: InputMaybe<string>;
  Rationale?: InputMaybe<string>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
}

export const useInsertDocumentAssessmentResult = createMutationHook({
  name: 'insertDocumentAssessmentResult',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.documentAssessmentResult.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: InsertDocumentAssessmentResultInput) => input,
  // Invalidation parity with the legacy Apollo evictFields:
  // document_assessment_result (+ aggregate), assessment,
  // internal_audit_report and oversight_assessment.
  invalidate: (trpc) => [
    trpc.frontend.documentAssessmentResult.pathKey(),
    trpc.frontend.assessment.pathKey(),
    trpc.frontend.internalAuditReport.pathKey(),
    trpc.frontend.oversight.pathKey(),
  ],
  mapResponse: (result: {
    Ids: string[];
  }): InsertDocumentAssessmentResultMutation => ({
    insertChildDocumentAssessmentResult: {
      __typename: 'InsertChildDocumentAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  graphqlDocument: InsertDocumentAssessmentResultDocument,
  graphqlVariables: (input: InsertDocumentAssessmentResultInput) => ({
    ...input,
  }),
  evictFields: [
    'document_assessment_result',
    'assessment',
    'internal_audit_report',
    'oversight_assessment',
    'document_assessment_result_aggregate',
  ],
});
